{
  "title": "骰子",
  "subtitle": "猜測結果在門檻之上或之下",
  "connecting": "連線中…",
  "connected": "已連線",
  "reconnecting": "重連中…",
  "unauthorized": "未授權",
  "authFailed": "登入失敗",
  "backLobby": "回大廳",
  "lobby": "大廳",
  "balance": "餘額 {{amount}}",
  "target": "門檻",
  "underWinRate": "低於 · 約 {{pct}}% 勝率",
  "overWinRate": "高於 · 約 {{pct}}% 勝率",
  "bet": "下注金額",
  "half": "1/2",
  "max": "全下",
  "under": "低於",
  "over": "高於",
  "chooseSide": "選擇預測方向",
  "winChance": "預估勝率",
  "selectedRule": "本局預測",
  "rollChoice": "擲骰 · {{choice}} {{target}}",
  "rolling": "骰子落下中…",
  "result": "結果",
  "winPayout": "贏得 +{{amount}}",
  "loseTag": "未中獎",
  "loseAmount": "損失 -{{amount}}",
  "resultAnnouncement": "結果 {{roll}}，{{outcome}}",
  "targetMark": "門檻 {{value}}",
  "winLine": "{{choice}} {{target}} · 贏 {{payout}} · {{odds}}x",
  "loseLine": "{{choice}} {{target}} · 輸 · {{odds}}x",
  "betFailed": "下注失敗",
  "quoteUnavailable": "目前無法取得賠率，請重試後再下注",
  "quotePendingShort": "取得中",
  "retryQuotes": "重新取得賠率",
  "balanceStale": "本局已完成，但餘額尚未同步；請重新整理餘額後再下注",
  "balanceOutcomeUnknown": "這筆下注結果尚未確認；請先重新整理餘額，再進行下一筆下注",
  "retryBalance": "重新整理餘額",
  "refreshingBalance": "正在更新餘額…",
  "retry": "重試",
  "quickChips": "快速籌碼",
  "close": "關閉",
  "rules": "遊戲規則",
  "rulesTitle": "骰子 (Dice) 遊戲規則",
  "rulesBody": "設定 0–100 區間內的目標門檻數值，並選擇「低於 (Under)」或「高於 (Over)」。系統將擲出 0.00–100.00 的隨機點數，命中預測即可獲得相應賠率派彩。",
  "errors": {
    "insufficient_funds": "餘額不足",
    "user_not_found": "找不到使用者",
    "invalid_bet": "下注金額無效",
    "invalid_target": "門檻必須在 2 到 98",
    "invalid_choice": "選擇無效",
    "unauthorized": "請先登入",
    "play_failed": "遊戲失敗",
    "unknown": "發生錯誤"
  }
}
